// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607130904/js/" + chunkId + "." + {"44":"0128a751","225":"35c3559e","481":"c234e392","486":"59114945","770":"dfda70df"}[chunkId] + ".0.352874241060836.chunk.js";
};